// src/components/AnimatedButton.tsx
import { useState } from "react";
import { motion } from "framer-motion";

interface AnimatedButtonProps {
  icon: React.ReactNode;
  text: string;
  isOpen: boolean;
}

const AnimatedButton: React.FC<AnimatedButtonProps> = ({
  icon,
  text,
  isOpen,
}) => {
  const [isHovered, setIsHovered] = useState<boolean>(true);

  return (
    <motion.div
      className={`bg-[#0276E9] flex items-center justify-center py-3 px-6 rounded-full ${
        isHovered || isOpen ? "gap-x-2" : "animate-wiggle"
      } active:scale-[0.9] duration-150`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(true)}
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      <motion.p
        initial={{ opacity: 0, width: 0 }}
        animate={{
          opacity: isHovered || isOpen ? 1 : 0,
          width: isHovered || isOpen ? "auto" : 0,
        }}
        transition={{ duration: 0.1, ease: "easeInOut" }}
        className="pointer-events-none select-none whitespace-nowrap text-sm"
      >
        {text}
      </motion.p>
      <div className="animate-wiggle">{icon}</div>
    </motion.div>
  );
};

export default AnimatedButton;
